export default function ChoiceGroup({
  label,
  name,
  options = [],
  value = "",
  values = [],
  onChange,
  multiple = false,
  hint,
}) {
  const selected = multiple ? values : value;

  function select(optionValue) {
    if (multiple) {
      const next = selected.includes(optionValue)
        ? selected.filter((item) => item !== optionValue)
        : [...selected, optionValue];
      onChange({ target: { name, value: next } });
      return;
    }
    onChange({ target: { name, value: optionValue } });
  }

  return (
    <fieldset className="field choice-fieldset">
      {label ? <legend className="field-label">{label}</legend> : null}
      {hint ? <p className="field-hint">{hint}</p> : null}
      <div className="choice-group" role={multiple ? "group" : "radiogroup"}>
        {options.map((option) => {
          const isOn = multiple ? selected.includes(option.value) : selected === option.value;
          return (
            <button
              key={option.value}
              type="button"
              className={`choice-chip${isOn ? " is-selected" : ""}`}
              onClick={() => select(option.value)}
              aria-pressed={isOn}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
